/**
 * Utility for stripping citation markers from text.
 *
 * This is a server-safe utility that can be used in both Server Components
 * and Client Components. It removes `[source-id]` patterns from text for
 * contexts where citations shouldn't be displayed (e.g., preview cards,
 * meta descriptions).
 */

/**
 * Strip citation markers from text.
 *
 * Removes `[source-id]` patterns from text. When `sourceIds` is supplied,
 * only markers for those authored sources are removed; other bracketed prose
 * remains literal.
 *
 * @example
 * ```ts
 * stripCitations("77% of patients search online.[pew-health]")
 * // => "77% of patients search online."
 * ```
 */
export function stripCitations(text: string, sourceIds?: readonly string[]): string {
  if (sourceIds) {
    const sourceIdSet = new Set(sourceIds);
    return text.replace(/\[([a-z0-9-]+)\]/g, (marker, sourceId: string) =>
      sourceIdSet.has(sourceId) ? '' : marker
    );
  }

  return text.replace(/\[[a-z0-9-]+\]/g, '');
}
